<template>
  <div class="date-content cp flex-col">
    <div class="top flex-b-c">
      <div class="date-select">
        <!-- <a-date-picker v-model="getDatePickerVal" /> -->
        <a-input-search
          size="large"
          v-model="keyword"
          placeholder="请输入日程标题"
          @search="onSearch"
        />
      </div>
      <div class="center txt-white">
        <a-space :size="15">
          <i
            class="el-icon-arrow-left"
            style="font-size: 14px; padding: 10px; opacity: 0.6"
            @click="changeMonth('prev')"
          ></i>
          <span class="font-w-b size14 white-s-nowrap">{{ getTitle }}</span>
          <i
            class="el-icon-arrow-right"
            style="font-size: 14px; padding: 10px; opacity: 0.6"
            @click="changeMonth('next')"
          ></i>
        </a-space>
      </div>
      <div class="flxR">
        <a-space :size="10">
          <!-- <div class="add" @click="showModal">新建日程</div> -->
          <div class="type flex">
            <span :class="type == 1 && 'active'" @click="changType(1)">月</span>
            <span :class="type == 2 && 'active'" @click="changType(2)">周</span>
            <span :class="type == 3 && 'active'" @click="changType(3)">日</span>
          </div>
          <div class="today" @click="clickToday">今天</div>
        </a-space>
      </div>
    </div>
    <div class="main mt15 flex-1" :class="noData && 'flex-c-c deep-bg'">
      <template v-if="!noData">
        <Month
          v-if="type == 1"
          :list="monthData"
          @toMore="toMore"
          @toDetail="toDetail"
        ></Month>
        <Week
          v-if="type == 2"
          :list="weekData"
          @toMore="toMore"
          @toDetail="toDetail"
        ></Week>
        <Day
          v-if="type == 3"
          :listobj="dayData"
          @pageSizeChange="pageSizeChange"
          @pageChange="pageChange"
          @toDetail="toDetail"
          @editForm="editFormHandle"
        ></Day>
      </template>
      <div class="flex-col-c-c date-none" v-else>
        <img src="@/assets/yf-img/date-none.png" />
        <p>当前无日程安排</p>
      </div>
    </div>

    <!-- 选择地点 -->
    <a-modal
      width="600px"
      title="切换地点"
      class="select_hall"
      :visible="addressVisible"
      :confirm-loading="confirmLoading"
      @cancel="addressVisible = false"
    >
      <div class="modal_content">
        <div class="address_box">
          <div
            class="address_list"
            v-if="addressList && addressList.length > 0"
          >
            <div
              class="address_item"
              :class="{ address_item_active: hall_cur.id == item.id }"
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectHallAddress(item)"
            >
              <span class="common_tip" v-if="item.useNum > 3">常用</span>
              <div class="address_top">{{ item.addressName }}</div>
              <div class="address_middle">
                {{ item.name }} {{ item.addressDetail }}
              </div>
            </div>
          </div>
          <a-empty v-else />
        </div>
      </div>
      <template #footer>
        <div class="flex-row justify-center align-center">
          <!-- <div class="flex-row align-center">已选场馆：<div class="hall_name">{{ hall_cur.addressName}}</div></div> -->
          <div>
            <a-button key="back" @click="closeModal">取消</a-button>
            <a-button key="submit" type="primary" @click="saveHallAddress"
              >确定</a-button
            >
          </div>
        </div>
      </template>
    </a-modal>

    <!-- 添加新地点 -->
    <a-modal
      class="select_hall"
      title="添加地点"
      :visible="addAddressVisible"
      :confirm-loading="confirmLoading"
      width="577px"
      @ok="subAddAddress"
    >
      <div class="">
        <div class="address_box">
          <el-form :model="newAddress" ref="newAddressRef" label-width="120px">
            <el-form-item
              label="地点名称"
              prop="addressName"
              :rules="[{ required: true, message: '请输入地点名称' }]"
            >
              <a-input
                size="large"
                v-model="newAddress.addressName"
                autocomplete="off"
                placeholder="请输入地点名称"
              />
            </el-form-item>
            <el-form-item
              label="省市区"
              prop="code"
              :rules="[{ required: true, message: '请选择省市区' }]"
            >
              <a-cascader
                v-model="newAddress.code"
                :fieldNames="fileladName"
                :options="areaList"
                @change="selectName"
                placeholder="请选择省市区"
              />
            </el-form-item>
            <el-form-item
              label="详细地址"
              prop="addressDetail"
              :rules="[{ required: true, message: '请输入详细地址' }]"
            >
              <a-input
                size="large"
                v-model="newAddress.addressDetail"
                autocomplete="off"
                placeholder="请输入详细地址"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </a-modal>

    <!-- 新建日程-选择参与人员 -->
    <!-- <treeModal
      :dataList="memberList_cy"
      :keys="cyCheck"
      :peoples="cyShow"
      :modalTitle="treeTitle"
      :modalVisible="cyVisible"
      @transmit="getResult"
    ></treeModal> -->

    <!-- 新建日程-同步日程人员 -->
    <!-- <treeModal
      :dataList="memberList_tb"
      :keys="tbCheck"
      :peoples="tbShow"
      :modalTitle="treeTitle"
      :modalVisible="tbVisible"
      @transmit="getResult"
    ></treeModal> -->

    <!-- 日程详情弹框 -->
    <a-modal
      :width="880"
      :footer="null"
      :maskClosable="false"
      :visible="sche_detail_visible"
      @cancel="sche_detail_visible = false"
    >
      <template #title>
        <div class="flex-b-c">
          <span>&nbsp;</span>
          <span class="head-title fs18 txt-white fwb">日程详情</span>
          <div class="icon-img">
            <div v-if="memberRole != 1">
              <img
                src="@/assets/yf-img/edit.png"
                style="margin-right:20px"
                v-if="memberRole > 1"
                @click="editImg(schedule_detail)"
                
              />
              <img
                src="@/assets/yf-img/del.png"
                v-if="memberRole > 2"
                @click="delImg(schedule_detail.id)"
              />
            </div>
          </div>
        </div>
      </template>
      <div class="modal_content">
        <div class="header">{{ schedule_detail.scheduleName }}</div>
        <div class="schedule_time_box flex-row align-center modal_item">
          <div
            class="schedule_time_item flex-column align-center"
            style="background: linear-gradient(135deg, #39cfbc 3%, #0e9fd1 95%)"
          >
            <span class="schedule_time">{{
              changeTime(schedule_detail.startTime, "HH:mm")
            }}</span>
            <span class="schedule_date"
              >{{ changeTime(schedule_detail.startTime, "MM月DD日")
              }}{{ changeTime(schedule_detail.startTime, "week") }}</span
            >
            <span class="schedule_text">开始时间</span>
          </div>
          <div
            class="schedule_time_item flex-column align-center"
            style="background: linear-gradient(135deg, #edbc6d 3%, #ea6b3a 95%)"
          >
            <span class="schedule_time">{{
              changeTime(schedule_detail.endTime, "HH:mm")
            }}</span>
            <span class="schedule_date"
              >{{ changeTime(schedule_detail.startTime, "MM月DD日")
              }}{{ changeTime(schedule_detail.startTime, "week") }}</span
            >
            <span class="schedule_text">结束时间</span>
          </div>
        </div>
        <div class="schedule_other modal_item">
          <div class="flex-row align-center">
            <span class="other_title item_header">日程地点</span>
            <div class="other_address">
              <div class="name">{{ schedule_detail.addressName }}</div>
              <div class="info">
                {{ schedule_detail.name }} {{ schedule_detail.addressDetail }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="join_member modal_item"
          v-if="
            schedule_detail.partInList && schedule_detail.partInList.length > 0
          "
        >
          <div class="item_header">参与人员</div>
          <div class="member_list flex-row">
            <div
              class="flex-column align-center mr-20"
              v-for="(item, index) in schedule_detail.partInList"
              :key="index"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="item.headImageUrl" />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="schedule_other modal_item">
          <div class="flex-row align-center">
            <span class="other_title item_header">备注信息</span>
            <span class="other_address">{{
              schedule_detail.remark ? schedule_detail.remark : "未添加描述"
            }}</span>
          </div>
        </div>
        <div
          class="filelist_box mt-20 modal_item"
          v-if="
            schedule_detail.fileInfoVoList &&
            schedule_detail.fileInfoVoList.length > 0
          "
        >
          <div class="item_header">附件</div>
          <div class="filelist_list">
            <div
              class="filelist_item mb10 flex-row align-center justify-between p10"
              v-for="(item, index) in schedule_detail.fileInfoVoList"
              :key="index"
            >
              <div><FileImageOutlined />{{ item.fileName }}</div>
              <div>
                {{ changeTime(item.createTime, "YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div>{{ item.name }}</div>
              <div class="opera_list">
                <a-button
                  class="line-btn down_btn"
                  size="small"
                  @click="download(item.filePath, item.fileName)"
                  >下载</a-button
                >
                <a-button
                  class="line-btn del_btn"
                  size="small"
                   v-if="memberRole > 2"
                  @click="delFile(item.id, index)"
                  >删除</a-button
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="join_member modal_item"
          v-if="schedule_detail.syncList && schedule_detail.syncList.length > 0"
        >
          <div class="item_header">同步日程人员</div>
          <div class="member_list flex-row">
            <div
              class="flex-column align-center mr-20"
              v-for="(item, index) in schedule_detail.syncList"
              :key="index"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="item.headImageUrl"></a-avatar>
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div
          class="create_member modal_item"
          v-if="schedule_detail.createByInfo"
        >
          <div class="avatar_box flex-row align-center">
            <span>发布人：</span>
            <a-avatar
              :size="32"
              :src="schedule_detail.createByInfo.headImageUrl"
              style="margin-left: 4px; margin-right: 12px"
            ></a-avatar>
            <span style="color: #fff">{{
              schedule_detail.createByInfo.name
            }}</span>
            <span>/</span>
            <span>{{ schedule_detail.createByInfo.positionName }}</span>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 新建日程 -->
    <a-modal
      :title="title"
      width="640px"
      :visible="schedule_visible"
      :confirm-loading="false"
      :maskClosable="false"
      @ok="addSchedule"
      @cancel="resetForm"
    >
      <el-form
        :model="schedule_form"
        ref="scheduleRule"
        label-width="120px"
        style="color: #1890ff"
      >
        <el-form-item
          label="日程标题"
          name="scheduleName"
          :rules="[{ required: true, message: '日程标题' }]"
        >
          <a-input
            size="large"
            v-model="schedule_form.scheduleName"
            placeholder="日期标题"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="日程日期"
          name="date"
          :rules="[{ required: true, message: '请选择日程日期' }]"
        >
          <el-date-picker
            v-model="schedule_form.date"
            placeholder="请选择日程日期"
          />
        </el-form-item>
        <el-form-item
          label="日程开始时间"
          name="startTime"
          :rules="[{ required: true, message: '请选择日程开始时间' }]"
        >
          <el-time-picker
            v-model="schedule_form.startTime"
            format="HH:mm"
            placeholder="请选择日程开始时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item
          label="日程结束时间"
          name="endTime"
          :rules="[{ required: true, message: '请选择日程结束时间' }]"
        >
          <el-time-picker
            v-model="schedule_form.endTime"
            format="HH:mm"
            placeholder="请选择日程结束时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item
          label="参与人员"
          :rules="[{ required: false, message: '选择人员' }]"
          v-if="[1, 3, 4].includes(userType)"
        >
          <div class="sporter_list flex-row flexWrapTree">
            <div
              class="sporter_item flex-column align-center"
              v-for="memberItem in cyShow"
              :key="memberItem.id"
              :title="memberItem.name"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="memberItem.headImageUrl" />
              </div>
              <span class="sporter_name">{{ memberItem.name }}</span>
            </div>
            <div
              class="sporter_item flex-column align-center pointer elIconPlus"
              @click="editSporter(1)"
            >
              <i
                class="el-icon-circle-plus-outline"
              ></i>
              <span class="upload_name">选择参与人员</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item
          :label="[3, 4].includes(userType) ? '日程地点' : '训练地点'"
          :rules="[{ required: false, message: '请选择地点' }]"
          v-if="memberRole > 2 || editDateType == 1"
        >
          <div class="addressMain">
            <div class="result">
              <div class="result_name">{{ schedule_form.addressName }}</div>
              <div class="result_info">
                {{ schedule_form.name }}{{ schedule_form.addressDetail }}
              </div>
            </div>
            <div class="line">
              <div class="btn btn_address" @click="selectAddressList">
                <UnorderedListOutlined />切换地址
              </div>
              <div class="btn btn_add" @click="addAddress">
                <PlusCircleOutlined />添加地址
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="[3, 4].includes(userType) ? '备注说明' : '训练内容'"
        >
          <a-textarea
            v-model="schedule_form.remark"
            placeholder="输入内容"
            :show-count="true"
            :rows="3"
            :maxlength="100"
          />
        </el-form-item>
        <el-form-item
          label="上传附件"
          :rules="[{ required: false, message: '请上传附件' }]"
        >
          <!-- <a-upload :file-list="schedule_form.fileList" name="file" :multiple="false" :max-count="count"
            :action="`${http}/api/file/uploadOss`" :headers="headers" @change="handleChange"
            :defaultFileList="schedule_form.fileList" accept=".rar, .zip, .doc, .docx, .pdf"
            :beforeUpload="beforeUpload">
            <a-button class="upload_btn">
              <upload-outlined></upload-outlined>
              上传文件
            </a-button>
          </a-upload>
          <p class="upload_tip">
            支持格式：rar.zip.doc.docx.pdf，单个文件不能超过20MB
          </p> -->
          <el-upload
            class="upload-demo"
            accept=".rar, .zip, .doc, .docx, .pdf"
            name="file"
            :limit="1"
            :action="`${http}/api/file/uploadOss`"
            :on-change="handleElChange"
            :on-remove="handleRemove"
            :beforeUpload="beforeUpload"
            :headers="headers"
            :file-list="schedule_form.fileList"
          >
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>
          <div class="tips" style="color: #999">
            支持格式：rar.zip.doc.docx.pdf，单个文件不能超过20MB
          </div>
        </el-form-item>
        <el-form-item
          :label="[1, 3, 4].includes(userType) ? '同步日程人员' : '协作人员'"
          :rules="[{ required: false, message: '选择人员' }]"
          v-if="memberRole > 2 || editDateType == 1"
        >
          <div class="sporter_list flex-row flexWrapTree">
            <div
              class="sporter_item flex-column align-center"
              v-for="syncItem in tbShow"
              :key="syncItem.id"
              :title="syncItem.name"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="syncItem.headImageUrl" />
              </div>
              <span class="sporter_name">{{ syncItem.name }}</span>
            </div>
            <div
              class="sporter_item flex-column align-center pointer elIconPlus"
              @click="editSporter(2)"
            >
              <i class="el-icon-circle-plus-outline"></i>
              <span class="upload_name" v-if="[1, 3, 4].includes(userType)"
                >选择教练员</span
              >
              <span class="upload_name" v-else>选择人员</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import Month from "./month";
import Day from "./day";
import Week from "./week";
// import treeModal from "../components/treeModal.vue";
export default {
  inject: ["passTime", "callBack"],
  props: ["passtype"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      scheduleStatus: "",
      memberRole: "", //大于1可编辑，大于2可 取消 删除
      // 选择和添加地点-start
      fileladName: {
        label: "name",
        value: "code",
        children: "areaList",
      },
      addAddressVisible: false,
      jsonRibbit: [],
      newAddress: {
        addressName: null,
        addressDetail: null,
        code: [],
        name: [],
      },
      selectAddress_visible: false,
      addressVisible: false,
      addressList: [],
      hall_cur: {},
      // 选择和添加地点-end

      keyword: "",
      editDateType: 1,
      title: "新建日程",
      schedule_detail: {}, //日程详情数据
      type: 1,
      noData: false,
      schedule_visible: false,
      sche_detail_visible: false,
      monthData: [],
      weekData: [],
      dayData: {
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      headers: {
        system: 1,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      schedule_file: [],
      memberList: [],
      joinList: [], // 参与人员
      schedule_form: {
        scheduleName: undefined,
        startTime: undefined,
        endTime: undefined,
        sportsHallId: undefined,
        remark: undefined,
        syncList: [],
        partInList: [],
        fileList: [],
        date: undefined,
      },
      http: process.env.VUE_APP_BASE_API,

      // 选择成员--start
      treeType: null,
      cyShow: [],
      cyCheck: [],
      cyVisible: false,
      memberList_cy: [],
      tbShow: [],
      tbCheck: [],
      tbVisible: false,
      memberList_tb: [],
      kjShow: [],
      kjCheck: [],
      kjVisible: false,
      memberList_kj: [],
      treeData: [],
      checkedKeys: [],
      areaList: this.$store.state.areaList,
      treeTitle: "",
      treeVisible: false,
      // 选择成员--end
      formLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
      },
      userType: this.$store.state.user.user.type, //用户类型
    };
  },
  components: {
    Month,
    Day,
    Week,
    // treeModal,
  },
  computed: {
    changeTime() {
      return function (time, type) {
        type = type ? type : "YYYY-MM-DD hh:mm:ss";
        if (type == "week") {
          const obj = {
            0: "周日",
            1: "周一",
            2: "周二",
            3: "周三",
            4: "周四",
            5: "周五",
            6: "周六",
          };
          return obj[new Date(time).getDay()];
        }
        return moment(time).format(type);
      };
    },
    getTitle() {
      // console.log(this.passTime());
      if (this.type == 1) {
        return this.getDateTitle;
      } else if (this.type == 2) {
        return this.getWeekRange;
      } else {
        return `${moment(this.passTime()).format("yyyy.MM.DD")}`;
      }
    },
    // 周一和周日
    getMinMax() {
      // 获取星期
      const date = this.passTime();
      const day = date.getDay() || 7;
      const min = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - (day - 1)
      );
      const max = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + (7 - day),
        23,
        59,
        59
      );
      return {
        min,
        max,
      };
    },
    // 周的范围
    getWeekRange() {
      const { min, max } = this.getMinMax;
      return `${moment(min).format("yyyy.MM.DD")}-${moment(max).format(
        "yyyy.MM.DD"
      )}`;
    },
    getDatePickerVal: {
      get() {
        return moment(this.passTime(), "YYYY-MM-DD");
      },
      set(e) {
        if (e) {
          // 通知父级改变时间
          this.callBack(new Date(e.format("YYYY/MM/DD HH:mm:ss")));
        } else {
          this.callBack(new Date());
        }
      },
    },
    getDateTitle() {
      let date = this.getDateFromFa;
      return `${date.getFullYear()}.${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
    },
    // 获取父级传来的时间
    getDateFromFa() {
      console.log(this.passTime());
      return this.passTime();
    },
  },
  watch: {
    passtype(val) {
      if (val) {
        this.callBack(new Date(+val.time));
        this.changType(val.type);
      }
    },
    getDateFromFa: {
      handler(val) {
        if (val) {
          console.log(val);
          this.getList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    delImg(id) {
      const params = {
        ids: [id],
      };
      this.$axios
        .post(`/sys/schedule/del`, params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            // 当前页面删除完后就请求上一页面
            if (this.dayData.pageNum > 1 && this.dayData.list.length == 1) {
              this.pageChange(this.dayData.pageNum - 1);
            } else {
              // 刷新数据
              this.callBack(new Date(+this.passTime()));
            }
          }
        })
        .finally(() => {
          this.sche_detail_visible = false;
        });
    },
    delFile(id, index) {
      this.$axios.post("/api/v1/file/del", { id: id }).then((res) => {
        if (res.code == 200) {
          this.schedule_detail.fileInfoVoList.splice(index, 1);
        }
      });
    },
    download(url, name) {
      var $a = document.createElement("a");
      $a.setAttribute("href", url);
      $a.setAttribute("download", name);

      var evObj = document.createEvent("MouseEvents");
      evObj.initMouseEvent(
        "click",
        true,
        true,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        true,
        false,
        0,
        null
      );
      $a.dispatchEvent(evObj);
    },

    // 更多日程
    toMore(date) {
      this.type = 3;
      this.callBack(new Date(date));
    },
    fileFormatter(data) {
      //已上传附件的格式
      let file = {
        uid: data.id, // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
        name: data.fileName, // 文件名
        status: "done", // 状态有：uploading done error removed
        response: '{"status": "success"}', // 服务端响应内容
      };
      return file;
    },
    editImg(detail) {
      this.sche_detail_visible = false;
      this.editFormHandle(detail);
    },
    // 编辑日程
    editFormHandle({ id }) {
      // 获取日程详情
      this.$axios.get(`/sys/schedule/getInfo/${id}`).then((res) => {
        if (res.code == 200) {
          const data = res.data;
          
          this.schedule_form = { ...data };
          // 日期回显需要转成moment对象
          // this.schedule_form.date = moment(data.startTime).format("yyyy-MM-DD");
          this.schedule_form.date = moment(data.date).valueOf("yyyy-MM-DD"),
          // console.log(moment(data.date).valueOf("yyyy-MM-DD"),'moment(data.date).valueOf("yyyy-MM-DD")');

          this.schedule_form.startTime = moment(data.startTime);
          this.schedule_form.endTime = moment(data.endTime);
          this.schedule_form.partInList = [];
          data.partInList.map((item) => {
            this.schedule_form.partInList.push(item.memberId);
          });
          this.schedule_form.syncList = [];
          data.syncList.map((item) => {
            this.schedule_form.syncList.push(item.memberId);
          });

          // 训练人员
          this.cyShow = [];
          res.data.partInList.map((item) => {
            let obj = {
              id: item.memberId,
              name: item.name,
              headImageUrl: item.headImageUrl,
            };
            this.cyShow.push(obj);
          });
          this.cyCheck = res.data.partInList.map((i) => {
            return i.memberId;
          });

          // 同步日程人员
          this.tbShow = [];
          res.data.syncList.map((item) => {
            let obj = {
              id: item.memberId,
              name: item.name,
              headImageUrl: item.headImageUrl,
            };
            this.tbShow.push(obj);
          });
          this.tbCheck = res.data.syncList.map((i) => {
            return i.memberId;
          });

          // 对上传的附件做回显
          this.schedule_form.fileList = [];
          data.fileInfoVoList.map((item) => {
            this.schedule_form.fileList.push(this.fileFormatter(item)); //已上传的附件
            let obj = {
              fileName: item.fileName,
              filePath: item.filePath,
              fileSize: item.fileSize,
              id: item.id,
            };
            this.schedule_file.push(obj); //提交时拿的字段，把已经上传的附件添加进去
          });
          this.editDateType = 2;
          this.title = "编辑日程";
          this.schedule_visible = true;
        }
      });
    },
    showModal() {
      this.editDateType = 1;
      this.title = "新建日程";
      this.schedule_visible = true;
    },
    dateChange(e, type) {
      const start = this.schedule_form.startTime;
      const end = this.schedule_form.endTime;
      if (start && end) {
        const startstr = moment(start).format("yyyy-MM-DD HH:mm:ss");
        const endstr = moment(end).format("yyyy-MM-DD HH:mm:ss");
        if (startstr >= endstr) {
          this.$message.error("日程开始时间必须小于结束时间");
          if (type == 1) {
            this.schedule_form.startTime = undefined;
          } else if (type == 2) {
            this.schedule_form.endTime = undefined;
          }
        }
      }
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    getDisabledStartHours() {
      const hours = [];
      // 排除当前时间段比开始时间还早的小时
      const h = moment().hours();
      for (let i = 0; i < this.range(0, 24).length; i++) {
        if (i < h) {
          hours.push(i);
        }
      }
      return hours;
    },
    getDisabledStartMinutes(selectedHour) {
      const minutes = [];
      const h = moment().hours();
      const m = moment().minutes();
      if (selectedHour === h) {
        for (var i = 0; i < this.range(0, 60).length; i++) {
          if (i < m) {
            minutes.push(i);
          }
        }
      }
      return minutes;
    },
    getDisabledEndHours() {
      const hours = [];
      // 排除当前时间段比开始时间还早的小时
      if (this.schedule_form.startTime) {
        const h = moment(this.schedule_form.startTime).hours();
        for (let i = 0; i < this.range(0, 24).length; i++) {
          if (i < h) {
            hours.push(i);
          }
        }
      }
      return hours;
    },
    getDisabledEndMinutes(selectedHour) {
      const minutes = [];
      if (this.schedule_form.startTime) {
        const h = moment(this.schedule_form.startTime).hours();
        const m = moment(this.schedule_form.startTime).minutes();
        if (selectedHour === h) {
          for (var i = 0; i < this.range(0, 60).length; i++) {
            if (i < m) {
              minutes.push(i);
            }
          }
        }
        return minutes;
      }
    },
    pageSizeChange(size) {
      this.dayData.pageNum = 1;
      this.dayData.pageSize = size;
      this.getList();
    },
    pageChange(page) {
      this.dayData.pageNum = page;
      this.getList();
    },
    onSearch() {
      this.dayData.pageNum = 1;
      this.getList();
    },
    getList() {
      let params = {};
      let url = "";
      if (this.type == 1) {
        // 月
        const year = this.getDateFromFa.getFullYear();
        const month = this.getDateFromFa.getMonth();
        url = "/sys/schedule/queryCalendarSchedule";
        params = {
          memberId: this.$route.query.id,
          keyword: this.keyword,
          start: +new Date(year, month, 1),
          end: +new Date(year, month + 1, 0, 23, 59, 59),
        };
      } else if (this.type == 2) {
        // 周
        url = "/sys/schedule/queryCalendarHourSchedule";
        params = {
          memberId: this.$route.query.id,
          keyword: this.keyword,
          start: +this.getMinMax.min,
          end: +this.getMinMax.max,
        };
      } else if (this.type == 3) {
        const y = this.getDateFromFa.getFullYear();
        const m = this.getDateFromFa.getMonth();
        const d = this.getDateFromFa.getDate();
        url = "/sys/schedule/pageList";
        params = {
          memberId: this.$route.query.id,
          keyword: this.keyword,
          start: +new Date(y, m, d),
          end: +new Date(y, m, d, 23, 59, 59),
          pageNum: this.dayData.pageNum,
          pageSize: this.dayData.pageSize,
        };
      }
      this.$axios.post(url, params).then((res) => {
        if (res.code == 200) {
          if (this.type == 1) {
            this.monthData = res.data;
          } else if (this.type == 2) {
            this.weekData = res.data;
          } else if (this.type == 3) {
            this.dayData = res.data;
          }
        }
      });
    },
    getMember() {
      this.$axios.post("/sys/member/listAll", {}).then((res) => {
        if (res.code == 200) {
          this.memberList = res.data;
          this.joinList = res.data;
        }
      });
    },
    getMember_cy() {
      this.$axios.get("/sys/member/scheduleMember", {}).then((res) => {
        if (res.code == 200) {
          this.memberList_cy = res.data;
        }
      });
    },
    getMember_tb() {
      this.$axios.get("/sys/member/scheduleSynMember", {}).then((res) => {
        if (res.code == 200) {
          this.memberList_tb = res.data;
        }
      });
    },
    // 获取场馆
    getHall() {
      this.$axios.post("/sys/authSelect/hallList", {}).then((res) => {
        if (res.code == 200) {
          this.hallList = res.data;
        }
      });
    },
    toDetail(id) {
      // 获取日程详情
      this.$axios.get(`/sys/schedule/getInfo/${id}`).then((res) => {
        if (res.code == 200) {
          this.schedule_detail = res.data;
          console.log(res.data,'详情');
          this.sche_detail_visible = true;
          this.memberRole = res.data.memberRole;
          this.scheduleStatus = res.data.scheduleStatus;
        }
      });
    },
    resetForm() {
      this.schedule_form = {
        data: undefined,
        scheduleName: undefined,
        startTime: undefined,
        endTime: undefined,
        sportsHallId: undefined,
        remark: undefined,
        syncList: [],
        partInList: [],
        fileList: [],
      };
      this.schedule_visible = false;
      // this.$refs.scheduleRule.resetFields();
    },
    handleChange(info) {
      if (info.file.status != undefined && info.file.status != "error") {
        try {
          this.schedule_file = [];
          info.fileList &&
            info.fileList.map((item) => {
              let obj = {
                fileName: item.response.data.fileName,
                filePath: item.response.data.url,
                fileSize: item.response.data.fileSize,
              };
              this.schedule_file.push(obj);
            });
          if (
            info.file.response &&
            info.file.response.code != 200 &&
            info.fileList.length <= 0
          ) {
            this.schedule_file = [];
          }
        } catch (e) {}
      }
    },
    handleElChange(file, fileList) {
      console.log(file, fileList, 111);
      if (file.status === "success") {
        this.schedule_file = fileList.map((item) => {
          return {
            fileName: item.response.data.fileName,
            filePath: item.response.data.url,
            fileSize: item.response.data.fileSize,
            id: item.uid,
          };
        });
      }
      console.log(this.schedule_file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList, 22);
      this.schedule_file = fileList;
    },

    // 添加运动员--添加或编辑
    editSporter(type) {
      this.treeType = type;
      if (type == 1) {
        this.cyVisible = true;
        this.treeTitle = "选择参与人员";
      }
      if (type == 2) {
        this.tbVisible = true;
        this.treeTitle = "选择同步人员";
      }
    },
    getResult(res) {
      console.log(res.length);
      if (Array.isArray(res)) {
        if (this.treeType == 1) {
          this.cyShow = res;
          this.cyCheck = res.map((i) => {
            return i.id;
          });
        }
        if (this.treeType == 2) {
          this.tbShow = res;
          this.tbCheck = res.map((i) => {
            return i.id;
          });
        }
      }
      if (this.treeType == 1) this.cyVisible = false;
      if (this.treeType == 2) this.tbVisible = false;
    },

    // 新建日程
    addSchedule() {
      this.$refs.scheduleRule
        .validate(["scheduleName", "startTime", "endTime", "date"])
        .then(() => {
          let dateStr = moment(this.schedule_form.date).format("yyyy-MM-DD");
          let startStr = moment(this.schedule_form.startTime).format("HH:mm");
          let endStr = moment(this.schedule_form.endTime).format("HH:mm");
          let startTimeStr = dateStr + " " + startStr;
          let endTimeStr = dateStr + " " + endStr;

          // 参与人员
          let partin_arr = [];
          if (this.cyShow && this.cyShow.length > 0) {
            this.cyShow.map((item) => {
              partin_arr.push({ memberId: item.id });
            });
          }
          // 同步日程人员
          let sync_arr = [];
          if (this.tbShow && this.tbShow.length > 0) {
            this.tbShow.map((item) => {
              sync_arr.push({ memberId: item.id });
            });
          }

          let param = {
            scheduleName: this.schedule_form.scheduleName,
            addressId: this.schedule_form.addressId
              ? this.schedule_form.addressId
              : "",
            startTime: new Date(startTimeStr).getTime(),
            endTime: new Date(endTimeStr).getTime(),
            sportsHallId: this.schedule_form.sportsHallId
              ? this.schedule_form.sportsHallId
              : "",
            remark: this.schedule_form.remark ? this.schedule_form.remark : "",
            syncList: sync_arr,
            partInList: partin_arr,
            fileInfoSaveDTOS: this.schedule_file,
            type: 2,
          };
          if (this.editDateType == 1) {
            // 新建
            this.$axios.post("/sys/schedule/add", param).then((res) => {
              if (res.code == 200) {
                // this.schedule_visible = false;
                // 清空表单
                this.resetForm();
                // 刷新数据
                this.callBack(new Date(+this.passTime()));
              }
            });
          } else if (this.editDateType == 2) {
            // 编辑
            param.id = this.schedule_form.id;
            this.$axios.post("/sys/schedule/edit", param).then((res) => {
              if (res.code == 200) {
                // this.schedule_visible = false;
                // 清空表单
                this.resetForm();
                // 刷新数据
                this.callBack(new Date(+this.passTime()));
              }
            });
          }
        })
        .catch(() => {
          console.log("校验不通过");
        });
    },
    handleOk() {},
    clickToday() {
      this.callBack(new Date());
    },
    changeMonth(type) {
      // 切换月份
      let date = this.getDateFromFa;
      let val;
      if (this.type == 1) {
        if (type == "prev") {
          val = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        } else {
          val = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }
      } else if (this.type == 2) {
        if (type == "prev") {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 7
          );
        } else {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 7
          );
        }
      } else if (this.type == 3) {
        if (type == "prev") {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 1
          );
        } else {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 1
          );
        }
      }

      // 通知父级改变时间
      this.callBack(val);
    },
    changType(type) {
      if (this.type != type) {
        this.type = type;
        this.getList();
      }
    },

    // 日程弹窗-start

    // 新建日程-日程地点-start
    selectAddressList() {
      this.$axios.get("/api/drill/findAddressByMemberId").then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.addressList = res.data;
          this.addressVisible = true;
        }
      });
    },

    // 添加地址
    addAddress() {
      this.addAddressVisible = true;
    },

    // 选择省市区
    selectName(e, value) {
      // console.log(value)
      // console.log(this.newAddress.name)
      value.forEach((ele) => {
        console.log(ele);
        this.newAddress.name.push(ele.name);
      });
      // this.newAddress.code.join(',')
      // this.newAddress.name.join('/')
      // console.log(this.newAddress)
    },

    subAddAddress() {
      this.$refs.newAddressRef
        .validate(["addressName", "code", "addressDetail"])
        .then(() => {
          this.subAddressApi();
        })
        .catch(() => {
          console.log("校验不通过");
        });
    },

    subAddressApi() {
      let param = this.newAddress;
      param.code = param.code.join(",");
      param.name = param.name.join("/");
      this.$axios.post("/api/drill/edit", param).then((res) => {
        if (res.code == 200) {
          this.$message.success("地点添加成功");
          this.addAddressVisible = false;
          param = {};
          this.newAddress = {
            name: [],
            code: [],
            addressName: null,
            addressDetail: null,
          };
          setTimeout(() => {
            this.selectAddressList();
          }, 1000);
        }
      });
    },

    selectHallAddress(item) {
      this.hall_cur = item;
    },

    closeModal() {
      this.addressVisible = false;
    },

    saveHallAddress() {
      if (!this.hall_cur.id) {
        message.error("请选择地点");
        return;
      }
      this.schedule_form.addressId = this.hall_cur.id;
      this.schedule_form.name = this.hall_cur.name;
      this.schedule_form.addressName = this.hall_cur.addressName;
      this.schedule_form.addressDetail = this.hall_cur.addressDetail;
      this.addressVisible = false;
    },
    // 日程弹窗-end
  },
  created() {
    this.getHall();
    // this.getMember();
    this.getMember_cy();
    this.getMember_tb();

    if (localStorage.getItem("ribbit-client")) {
      let ribbit = localStorage.getItem("ribbit-client");
      this.jsonRibbit = JSON.parse(ribbit);
    }
  },
};
</script>
<style lang='less' scoped>
/deep/ .ant-input-search-icon {
  color: white;
}
.modal_content {
  height: 400px;
  overflow-y: scroll;
  color: #fff;
  .modal_item {
    margin-bottom: 48px;
  }
  .header {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 21px;
  }
  .item_header {
    font-size: 16px;
  }
  .schedule_time_box {
    color: #ffffff;
    .schedule_time_item {
      width: 180px;
      padding: 15px 0 10px 0;
      margin-right: 32px;
      &:last-child {
        margin-right: 0;
      }
    }
    .schedule_date {
      font-size: 12px;
      margin: 5px 0;
    }
    .schedule_time {
      font-size: 25px;
      font-weight: 500;
    }
    .schedule_text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      padding: 2px 10px;
      background: #f2f2f2;
      border-radius: 15px;
    }
  }
  .schedule_other {
    .other_title {
      margin-right: 24px;
    }
    .other_address {
      color: #bcbcbc;
    }
  }
  .join_member {
    .item_header {
      margin-bottom: 21px;
    }
    .avatar_box {
      width: 68px;
      height: 68px;
      background: linear-gradient(132deg, #00ffe0 16%, #00c4ff 79%);
      border-radius: 50%;
      margin-bottom: 8px;
    }
  }
  .create_member {
    font-size: 14px;
    color: #bcbcbc;
    background: #282f54;
    padding: 16px 24px;
  }
  .filelist_box {
    .item_header {
      margin-bottom: 21px;
    }
    .filelist_item {
      &:nth-of-type(2n-1) {
        background: #282f54;
      }
      .opera_list {
        .down_btn {
          margin-right: 8px;
        }
      }
    }
  }
  .desc-label {
    color: var(--text-color);
  }
}
.date-content {
  margin-left: 24px;
  user-select: none;
  min-height: 100%;
  box-sizing: border-box;
  .deep-bg {
    background: #1c2242;
  }
  .date-none {
    height: 100%;
    img {
      width: 81px;
    }
    p {
      margin-top: 31px;
      height: 27px;
      font-size: 20px;
      color: #bcbcbc;
    }
  }
  .date-select {
    width: 300px;
  }
  .add,
  .today {
    width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
  }
  .add {
    background: #1890ff;
    margin-right: 16px;
  }
  .today {
    width: 80px;
    background: #141937;
    margin-left: 16px;
    border: 1px solid #282f54;
  }
  .type {
    span {
      width: 54px;
      line-height: 41px;
      border: 1px solid #282f54;
      text-align: center;
      color: #bcbcbc;
      box-sizing: border-box;
      &:nth-of-type(1) {
        border-radius: 4px 0px 0px 4px;
      }
      &:nth-of-type(3) {
        border-radius: 0 4px 4px 0;
      }
      &.active {
        border-color: #1890ff;
        color: #1890ff;
      }
    }
  }
}
/deep/ .ant-select-multiple .ant-select-selection-item {
  background: rgb(28, 34, 66) !important;
}
/deep/ .ant-select-multiple .ant-select-selection-item-remove {
  color: white !important;
}
/deep/ .upload.ant-btn {
  background: #282f54 !important;
  border-color: #282f54 !important;
  color: #999999 !important;
}
.gray {
  color: #999999;
}
.head-title {
  transform: translateX(40px);
}
.icon-img {
  padding-right: 40px;
  img {
    width: 12px;
  }
}
.img-wrap {
  width: 180px;
  height: 115px;
  box-sizing: border-box;
}
.img1 {
  background: url(/assets/yf-img/green-bg.png) left top no-repeat;
  background-size: cover;
  margin-right: 32px;
}
.img2 {
  background: url(/assets/yf-img/orange-bg.png) left top no-repeat;
  background-size: cover;
}
.join-people {
  > section {
    margin-right: 44px;
  }
  img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }
}
.table {
  width: 100%;
  tr:nth-of-type(2n-1) {
    background: #282f54;
  }
  tr {
    border-radius: 4px;
    padding: 0 16px;
  }
  td {
    height: 50px;
    vertical-align: middle;
    padding: 10px 16px;
    &:nth-of-type(1) {
      width: 25%;
    }
    &:nth-of-type(2) {
      width: 36%;
    }
    &:nth-of-type(3) {
      width: 20%;
    }
    &:nth-of-type(4) {
      width: 19%;
      white-space: nowrap;
    }
    .ant-btn-primary {
      color: #1890ff !important;
    }
    .ant-btn-dangerous {
      background: none !important;
    }
  }
}
/deep/.ant-time-picker {
  width: 100% !important;
}
.addressMain {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 5px;
  // max-width: 290px;
  .result {
    margin-bottom: 20px;
    .result_name {
      font-size: 15px;
      color: #fff;
    }
    .result_info {
      color: #fff;
    }
  }
  .line {
    display: flex;
    .btn {
      color: rgba(255, 255, 255, 0.6);
      border: 1px solid rgba(255, 255, 255, 0.6);
      padding: 5px 10px;
      border-radius: 3px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-right: 5px;
      }
    }
    .btn:hover {
      border: 1px solid rgba(255, 255, 255, 1);
      color: rgba(255, 255, 255, 1);
    }
    .btn_address {
    }
    .btn_add {
    }
  }
}
.address_list {
  height: 400px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0;
  }
  .address_item {
    padding: 13px 20px 8px 20px;
    background: #282f54;
    margin-bottom: 16px;
    border-radius: 4px;
    position: relative;
    border: 1px solid #282f54;
    .common_tip {
      font-size: 12px;
      color: #ffffff;
      padding: 4px 12px;
      background: #fa6ba4;
      border-radius: 4px 4px 0px 4px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .address_top {
      font-size: 15px;
    }
    .address_middle {
      font-size: 12px;
      color: #bcbcbc;
      margin-top: 10px;
    }
    .address_bottom {
      font-size: 12px;
      color: #bcbcbc;
      border-top: 1px solid #232948;
      padding-top: 8px;
    }
  }
  .address_item_active {
    border-color: #1890ff;
  }
}
</style>